module.exports = __webpack_public_path__ + "static/media/DigiFleet_frontpage.e420835f.png";